{
  "WHATSAPP_TEMPLATES": {
    "MODAL": {
      "TITLE": "WhatsApp Şablonları",
      "SUBTITLE": "Göndermek istediğiniz WhatsApp şablonunu seçin",
      "TEMPLATE_SELECTED_SUBTITLE": "Şablonu yapılandır: {templateName}"
    },
    "PICKER": {
      "SEARCH_PLACEHOLDER": "Şablon Ara",
      "NO_TEMPLATES_FOUND": "İçin hiç şablon bulunamadı",
      "HEADER": "Başlık",
      "BODY": "Gövde",
      "FOOTER": "Altbilgi",
      "BUTTONS": "Butonlar",
      "CATEGORY": "Kategori",
      "MEDIA_CONTENT": "Medya İçeriği",
      "MEDIA_CONTENT_FALLBACK": "medya içeriği",
      "NO_TEMPLATES_AVAILABLE": "WhatsApp şablonu mevcut değil. WhatsApp'tan şablonları senkronize etmek için yenile düğmesine tıklayın.",
      "REFRESH_BUTTON": "Şablonları yenile",
      "REFRESH_SUCCESS": "Şablonların yenilenmesi başlatıldı. Güncelleme birkaç dakika sürebilir.",
      "REFRESH_ERROR": "Şablonları yenileme işlemi başarısız oldu. Lütfen tekrar deneyin.",
      "LABELS": {
        "LANGUAGE": "Dil",
        "TEMPLATE_BODY": "Şablon İçeriği",
        "CATEGORY": "Kategori"
      }
    },
    "PARSER": {
      "VARIABLES_LABEL": "Değişkenler",
      "LANGUAGE": "Dil",
      "CATEGORY": "Kategori",
      "VARIABLE_PLACEHOLDER": "{variable} değerini girin",
      "GO_BACK_LABEL": "Geri Git",
      "SEND_MESSAGE_LABEL": "Mesaj Gönder",
      "FORM_ERROR_MESSAGE": "Lütfen göndermeden önce tüm değişkenleri doldurun",
      "MEDIA_HEADER_LABEL": "{type} Başlık",
      "OTP_CODE": "4-8 haneli OTP girin",
      "EXPIRY_MINUTES": "Süreyi (dakika) girin",
      "BUTTON_PARAMETERS": "Buton Parametreleri",
      "BUTTON_LABEL": "Buton {index}",
      "COUPON_CODE": "Kupon kodunu girin (maks. 15 karakter)",
      "MEDIA_URL_LABEL": "{type} URL’sini girin",
      "DOCUMENT_NAME_PLACEHOLDER": "Belge dosya adını girin (örneğin, Fatura_2025.pdf)",
      "BUTTON_PARAMETER": "Buton parametresini girin"
    }
  }
}
